import React, { FC, Fragment } from "react";
import { useTypedSelector } from "../redux";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { Colors } from "../styles";
import { isSignInWithEmailLink } from "../clients/FirebaseClient";
import { useLocation } from "react-router";

const useStyles = makeStyles(() => ({
    root: {
        color: Colors.mellowYellow,
    },
}));

interface Props {
    children: JSX.Element | JSX.Element[];
}

export const InitializerIndicator: FC<Props> = (props: Props) => {
    const initializing = useTypedSelector(
        (state) =>
            state.auth.waitingForAuthEvent || (state.auth.uid && !state.configuration.initialized),
    );
    const activities = useTypedSelector((state) => state.screen.activities);
    useLocation();
    const classes = useStyles();
    if (!initializing && !isSignInWithEmailLink(window.location.href)) {
        return (
            <Fragment>
                {props.children}
                {activities ? (
                    <div
                        style={{
                            position: "fixed",
                            backgroundColor: "#ffffff99",
                            display: "flex",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            justifyContent: "center",
                            alignItems: "center",
                            justifyItems: "center",
                            flexDirection: "column",
                        }}
                    >
                        <CircularProgress variant="indeterminate" className={classes.root} />
                    </div>
                ) : (
                    <Fragment />
                )}
            </Fragment>
        );
    }
    return (
        <div
            style={{
                position: "fixed",
                backgroundColor: "#ffffff99",
                display: "flex",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                justifyContent: "center",
                alignItems: "center",
                justifyItems: "center",
                flexDirection: "column",
            }}
        >
            {/*bin ich hier? {""+initializing} oder {""+isSignInWithEmailLink(window.location.href)} {location.toString()}*/}
            <CircularProgress variant="indeterminate" className={classes.root} />
        </div>
    );
};
